const __filename = "/app/components/cms/blocks/definitions_tabs/ns.js", __dirname = "/app/components/cms/blocks/definitions_tabs";
import WebComponent from '@rubygems/hue/app/components/web_component'

import { tabbed } from '/app/components/cms/tabbed'

// Upgrades the description list ns.rb rendered into the tab strip live draws — see ns.rb for why
// the list is the source rather than the tabs, and app/components/cms/tabbed.js for the widget.
//
// Everything specific to this block is here and it is two facts: a tab is a `dt`, and the panel it
// controls is the `dd` that followed it.
WebComponent.register(
  class extends WebComponent {
    // Matches `extend Hue::Phlex::CustomElement(:definitions_tabs)` — `buildName` would derive
    // `components-cms-blocks-definitions-tabs-ns` from the filename instead.
    static componentName = 'definitions-tabs'

    connectedCallback() {
      super.connectedCallback()
      this.upgrade()
    }

    upgrade() {
      const list = this.querySelector('dl')
      if (!list) return

      // Pairs, in document order. A `dt` with no `dd` after it is not a tab — ns.rb's `#rows`
      // already drops a half-filled row, so this only fires on hand-edited markup.
      const pairs = [...list.querySelectorAll('dt')]
        .map(term => [term, term.nextElementSibling])
        .filter(([, panel]) => panel?.tagName === 'DD')

      const widget = tabbed(
        pairs.map(([, panel]) => panel),
        { label: index => ({ visible: pairs[index][0].textContent.trim() }) }
      )
      // One definition is not a tab strip, it is a heading with a paragraph under it.
      if (!widget) return

      // The term's own class carries this block's styling, and the term has become the tab.
      widget.tablist.querySelectorAll('[role="tab"]').forEach((tab, index) => {
        const term = pairs[index][0]
        tab.className = term.className
        // Leaving it in the list would say every term twice.
        term.remove()
      })

      list.before(widget.tablist)
      this.dataset.upgraded = ''
    }
  }
)
